import { PICKER_PLATFORMS, logoUrl } from "../../lib/integrations";

interface PlatformLogosProps {
  platforms: string[];
}

export function PlatformLogos({ platforms }: PlatformLogosProps) {
  const resolved = platforms
    .map((id) => ({ id, platform: PICKER_PLATFORMS.find((p) => p.platform === id) }))
    .filter((p) => p.platform?.domain);

  return (
    <div className="inline-flex flex-wrap gap-y-1.5" style={{ maxWidth: `${10 * 28}px` }}>
      {resolved.map(({ id, platform }) => (
        <span
          key={id}
          className="relative group/tip mr-2"
        >
          {/* Natural-square brand logo, matching the report editor's connected-
              integration style (rounded-sm — no circle crop / white ring). */}
          <img
            src={logoUrl(platform!.domain!)}
            alt={platform!.displayName}
            className="w-5 h-5 rounded-sm object-contain"
            loading="lazy"
          />
          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 scale-95 group-hover/tip:opacity-100 group-hover/tip:scale-100 transition-all duration-150 pointer-events-none z-50">
            {/* Arrow */}
            <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-background border-r border-b border-input rotate-45 z-10" />
            {/* Label */}
            <span className="relative block bg-background text-foreground text-[13px] font-medium px-2.5 py-1 rounded-md border border-input shadow-xs whitespace-nowrap">
              {platform!.displayName}
            </span>
          </span>
        </span>
      ))}
    </div>
  );
}
